export default "__VITE_ASSET__b38b7987__"